import { LoadingCard } from '@/components/Base/LoadingCard/LoadingCard'
import { NoDataToDisplayCard } from '@/components/Base/NoDataToDisplayCard/NoDataToDisplayCard'
import { useAppSelector } from '@/hooks/use-app-selector'
import {
  ISummaryReport,
  ISummaryReportTransformData,
} from '@/interfaces/portfolioOptimization.interface'
import {
  getSummaryReport,
  getTransformSummaryData,
} from '@/services/portfolio-optimization/optimization-reports.service'
import { showSnackbar } from '@/states/snackbar.slice'
import { Box } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import ReportBox from '../ConstraintReport/ReportBox'

const SummaryReport: React.FC = () => {
  const appDispatch = useDispatch()
  const selectedReport =
    useAppSelector((s) => s.axiomReport.selectedReport) || {}
  const [summaryReportData, setSummaryReportData] = useState<ISummaryReport>(
    {} as ISummaryReport,
  )
  const [showLoader, setShowLoader] = useState<boolean>(true)
  const [summaryReportTransformData, setSummaryReportTransformData] = useState<
    ISummaryReportTransformData[]
  >([])

  useEffect(() => {
    setShowLoader(true)
    const fetchSummaryReport = async () => {
      try {
        const response = await getSummaryReport(selectedReport.reportId)
        setSummaryReportData(response)
      } catch (err) {
        appDispatch(
          showSnackbar({
            message: `Error fetching summary reports ${err instanceof Error ? err.message : String(err)}`,
            severity: 'error',
          }),
        )
        setSummaryReportData({} as ISummaryReport)
      } finally {
        setShowLoader(false)
      }
    }
    fetchSummaryReport()
  }, [selectedReport.reportId, appDispatch])

  useEffect(() => {
    const transformedData = getTransformSummaryData(summaryReportData)
    setSummaryReportTransformData(transformedData)
  }, [summaryReportData])

  return (
    <>
      {showLoader ? (
        <LoadingCard />
      ) : Object.keys(summaryReportData)?.length ? (
        <Box
          sx={{
            display: 'flex',
            flex: 1,
            gap: 2,
            marginX: 2,
            marginY: 1,
            overflow: 'auto',
          }}
          className='summary-report-section'
        >
          {summaryReportTransformData.map(
            (summaryItem: ISummaryReportTransformData, index: number) => (
              <ReportBox
                key={`summary-${summaryItem.title}-${index}`}
                title={summaryItem.title}
                data={summaryItem.data}
                styles={{ flex: 1 }}
              />
            ),
          )}
        </Box>
      ) : (
        <NoDataToDisplayCard />
      )}
    </>
  )
}

export default SummaryReport
